import api from "../api";

const login = (data) => {
  return api.getApiWithoutToken().post(api.getBaseUrl() + "login", data);
};
const registerUser = (data) => {
  return api.getApiWithoutToken().post(api.getBaseUrl() + "register", data);
};
const changePassword = (data) => {
  return api.getApi().post(api.getBaseUrl() + "change-password", data);
};
const forgotPassword = (data) => {
  return api
    .getApiWithoutToken()
    .post(api.getBaseUrl() + "forgot-password", data);
};
const resetPassword = (data) => {
  return api
    .getApiWithoutToken()
    .post(api.getBaseUrl() + "reset-password", data);
};
const getPreferences = () => {
  return api.getApi().get(api.getBaseUrl() + "users/preferences");
};
const updatePreferences = (data) => {
  return api.getApi().put(api.getBaseUrl() + "users/preferences", data);
};
const deleteMyAccount = (reason) => {
  return api.getApi().delete(api.getBaseUrl() + "users/my-account", {
    data: { reason },
  });
};

export {
  login,
  registerUser,
  changePassword,
  forgotPassword,
  resetPassword,
  getPreferences,
  updatePreferences,
  deleteMyAccount,
};
